import { FleetDatapoint, CompetitorStatus } from './types'

export function getCompetitorStatus (competitor: FleetDatapoint): CompetitorStatus {
  let status = CompetitorStatus.Fleet
  if (competitor.IsLineHonourRecord === true) {
    status = CompetitorStatus.RecordHolder
  } else {
    for (let i = 0; i < competitor.Categories.length; i++) {
      const cat = competitor.Categories[i]
      if (cat.CatPlace === 1 && cat.Name === 'Line Honours') {
        status = CompetitorStatus.RaceLeader
      } else if (cat.DivPlace === 1) {
        status = CompetitorStatus.DivisionLeader
      }
    }
  }
  if (competitor.Position.IsRetired === true) { status = CompetitorStatus.Retired }
  return status
}

export function replaceAt (str: string, index: number, replacement: string): string {
  return str.substr(0, index) + replacement + str.substr(index + replacement.length)
}

export function isLastDayOfMonth (time: string): boolean {
  const year = parseInt(time.slice(0, 4))
  const month = parseInt(time.slice(4, 6))
  const day = parseInt(time.slice(6, 8))

  if (month === 2 && year % 4 === 0 && day === 29) return true
  if (month === 2 && year % 4 !== 0 && day === 28) return true

  if ([4, 6, 9, 11].includes(month) && day === 30) return true
  if ([1, 2, 3, 5, 7, 8, 10, 12].includes(month) && day === 31) return true

  return false
}

export function generateValidRacetimeList (raceTimeMin: string, raceTimeMax: string): string[] {
  const list = [] as string[]

  list.push(raceTimeMin)

  if (parseInt(raceTimeMin) < parseInt(raceTimeMax)) {
    let stackOverflowProtection = 0
    while (parseInt(list[list.length - 1]) < parseInt(raceTimeMax) && stackOverflowProtection < 10000) {
      stackOverflowProtection++
      let currTime = list[list.length - 1]
      if (parseInt(currTime) % 10000 < 5000) {
        /* add 10 minutes up to 50 minutes */
        const newTime = parseInt(currTime) + 1000
        list.push(newTime.toString())
      } else {
        /* reset to zero minutes */
        currTime = replaceAt(currTime, 10, '0')
        if (parseInt(currTime.slice(8, 10)) < 23) {
          /* add an hour */
          const newTime = parseInt(currTime) + 10000
          list.push(newTime.toString())
        } else {
          /* reset to midnight */
          currTime = replaceAt(currTime, 8, '00')
          if (!isLastDayOfMonth(currTime)) {
            /* add a day */
            const newTime = parseInt(currTime) + 1000000
            list.push(newTime.toString())
          } else {
            /* reset to first of month */
            currTime = replaceAt(currTime, 6, '01')
            if (parseInt(currTime.slice(4, 6)) < 12) {
              /* add a month */
              const newTime = parseInt(currTime) + 100000000
              list.push(newTime.toString())
            } else {
              /* add a year */
              const newTime = parseInt(currTime) + 10000000000
              list.push(newTime.toString())
            }
          }
        }
      }
    }
  }
  return list
}
